import React from "react";
import ContractorsPage from "./ContractorsPage";
import useContractors from "./useContractors";

function Contractors() {
  return <ContractorsPage {...useContractors()} />;
}

export default Contractors;
